import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { fetchUsersCategory } from "DashboardUserAction";
import { fetchSettings } from "TicketAction";
import { INSTANCE_URL, APP_API_KEY } from "Constants";
import LocaleStrings from "Languages";

class Apis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: "",
    };
  }

  componentDidMount() {
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchSettings(this.props.session);
  }

  copyUrl = (item) => {
    this.setState({ copied: item });

    setTimeout(() => {
      this.setState({ copied: "" });
    }, 1000);
  };

  render() {
    var { session, userCategoryList } = this.props;
    var { copied } = this.state;
    // console.log("userCategoryList :- ", userCategoryList);

    var API_KEY =
      "334d0084d1d623a9a25c1ef92f5c6d1fdde9ceaacdadf9e2c13f39dba5586381";

    var category = _.filter(userCategoryList.data, (obj) => {
      return obj.type === "attendee";
    });

    var categoryId = category.length > 0 ? category[0].id : "";

    var usercreate1 = `Url: ${INSTANCE_URL}/api/v2/eventifyscript/createAppUser
                      Header: {
                        Content-Type: application/x-www-form-urlencoded,
                        X-DreamFactory-Api-Key: 334d0084d1d623a9a25c1ef92f5c6d1fdde9ceaacdadf9e2c13f39dba5586381
                      }
                      Method: Post
                      Payload: {
                        username: "firstname lastname"
                        firstname: "firstname"
                        lastname: "lastname"
                        email: "email"
                        eventid: ${session.eventid}
                        usercategory: ${categoryId}
                        comesfrom: "api"
                      }`;
    var usercreate2 = `curl -X POST /\
      ${INSTANCE_URL}/api/v2/eventifyscript/createAppUser /\
      -H 'content-type: application/x-www-form-urlencoded' /\
      -H 'x-dreamfactory-api-key: 334d0084d1d623a9a25c1ef92f5c6d1fdde9ceaacdadf9e2c13f39dba5586381' /\
      -d 'username=firstname%20lastname&firstname=firstname&lastname=lastname&email=email@gmail.com&eventid=${session.eventid}&usercategory=${categoryId}&comesfrom=api' /\
      `;

    return (
      <div className="text-break">
        <div className="custom-text1-primary-bold mb-10">
          {LocaleStrings.setting_apidoc_text_user_regi}
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="custom-text1-secondary-normal">
              {LocaleStrings.setting_apidoc_text_user_regi_definition}
            </div>
            <div className="mt-10">
              <div className="custom-text1-primary-medium">
                <u>{LocaleStrings.setting_apidoc_text_user_regi_header}</u>
              </div>
              <div className="api-doc-method-payloads-container mt-10">
                <div className="payload-item">
                  <span className="custom-text1-primary-normal">
                    Content-Type: application/x-www-form-urlencoded
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-normal">
                    X-DreamFactory-Api-Key: {API_KEY}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <div className="custom-text1-primary-medium">
                <u>{LocaleStrings.setting_apidoc_text_user_regi_payloads}</u>
              </div>
              <div className="api-doc-method-payloads-container mt-10">
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">username</span>
                  &nbsp;
                  <span className="text-custom-danger">
                    {LocaleStrings.required}
                  </span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {
                      LocaleStrings.setting_apidoc_text_user_regi_payload_username
                    }
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">firstname</span>
                  &nbsp;
                  <span className="text-custom-danger">
                    {LocaleStrings.required}
                  </span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {LocaleStrings.setting_apidoc_text_user_regi_payload_fname}
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">lastname</span>
                  &nbsp;
                  <span className="text-custom-danger">
                    {LocaleStrings.required}
                  </span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {LocaleStrings.setting_apidoc_text_user_regi_payload_lname}
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">email</span>
                  &nbsp;
                  <span className="text-custom-danger">
                    {LocaleStrings.required}
                  </span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {LocaleStrings.setting_apidoc_text_user_regi_payload_email}
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">eventid</span>
                  &nbsp;
                  <span className="text-custom-danger">
                    {LocaleStrings.required}
                  </span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {
                      LocaleStrings.setting_apidoc_text_user_regi_payload_eventid
                    }{" "}
                    ({session.eventid})
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">
                    usercategory
                  </span>
                  &nbsp;
                  <span className="text-custom-danger">
                    {LocaleStrings.required}
                  </span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {
                      LocaleStrings.setting_apidoc_text_user_regi_payload_categoryid
                    }{" "}
                    ({categoryId})
                  </span>
                </div>
                <div className="payload-item">
                  <span className="custom-text1-primary-medium">comesfrom</span>
                  &nbsp;
                  <span className="text-custom-danger">required</span>
                  &ensp;
                  <span className="custom-text1-secondary-normal">
                    {
                      LocaleStrings.setting_apidoc_text_user_regi_payload_comesfrom
                    }{" "}
                    ('api')
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="">
              <CopyToClipboard
                text={usercreate1}
                onCopy={() => this.copyUrl("usercreate1")}
              >
                <div className="text-right" style={{ textAlign: "end" }}>
                  <button type="button" className="btn i-custom-cross-popup">
                    {copied === "usercreate1" ? (
                      <i
                        className="fa fa-check text-custom-success"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i className="fa fa-clipboard" aria-hidden="true"></i>
                    )}
                  </button>
                </div>
              </CopyToClipboard>

              <div className="custom-text1-primary-medium">
                <span>{LocaleStrings.url}: </span>
                <span className="custom-text1-primary-normal">{`${INSTANCE_URL}/api/v2/eventifyscript/createAppUser`}</span>
              </div>
              <div>
                <span className="custom-text1-primary-medium">
                  {LocaleStrings.header}:{" "}
                </span>
                <span className="custom-text1-primary-normal">
                  {" "}
                  {`{`}
                  <br />
                  <span className="ml-15">
                    Content-Type: application/x-www-form-urlencoded,
                  </span>
                  <br />
                  <span className="ml-15">
                    X-DreamFactory-Api-Key: {API_KEY}
                  </span>
                  <br />
                  {`}`}
                </span>
              </div>
              <div>
                <span className="custom-text1-primary-medium">
                  {LocaleStrings.method}:{" "}
                </span>
                <span className="custom-text1-primary-normal">
                  {LocaleStrings.post}
                </span>
              </div>
              <div>
                <span className="custom-text1-primary-medium">
                  {LocaleStrings.payload}:{" "}
                </span>
                <span className="custom-text1-primary-normal">
                  {` {`}
                  <div className="pl-15">
                    <span className="custom-text1-primary-normal">
                      username: "firstname lastname"
                    </span>
                    <br />
                    <span className="custom-text1-primary-normal">
                      firstname: "firstname"
                    </span>
                    <br />
                    <span className="custom-text1-primary-normal">
                      lastname: "lastname"
                    </span>
                    <br />
                    <span className="custom-text1-primary-normal">
                      email: "email"
                    </span>
                    <br />
                    <span className="custom-text1-primary-normal">
                      eventid: {session.eventid}
                    </span>
                    <br />
                    <span className="custom-text1-primary-normal">
                      usercategory: {categoryId}
                    </span>
                    <br />
                    <span className="custom-text1-primary-normal">
                      comesfrom: "api"
                    </span>
                  </div>
                  {`}`}
                </span>
              </div>
            </div>

            <div className="mt-15 pt-15 divider-line-top">
              <CopyToClipboard
                text={usercreate2}
                onCopy={() => this.copyUrl("usercreate2")}
              >
                <div className="text-right mt-10" style={{ textAlign: "end" }}>
                  <button type="button" className="btn i-custom-cross-popup">
                    {copied === "usercreate2" ? (
                      <i
                        className="fa fa-check text-custom-success"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i className="fa fa-clipboard" aria-hidden="true"></i>
                    )}
                  </button>
                </div>
              </CopyToClipboard>

              <div className="custom-text1-primary-medium">curl -X POST \</div>
              <div className="custom-text1-primary-medium pl-15">
                {`${INSTANCE_URL}/api/v2/eventifyscript/createAppUser`} \
              </div>
              <div className="pl-15">
                <span className="custom-text1-primary-medium">-H</span>{" "}
                <span className="custom-text1-primary-medium">'</span>
                <span className="custom-text1-theme-medium">
                  content-type: application/x-www-form-urlencoded
                </span>
                <span className="custom-text1-primary-medium">' \</span>
              </div>
              <div className="pl-15">
                <span className="custom-text1-primary-medium">-H</span>{" "}
                <span className="custom-text1-primary-medium">'</span>
                <span className="custom-text1-theme-medium">
                  x-dreamfactory-api-key: {API_KEY}
                </span>
                <span className="custom-text1-primary-medium">' \</span>
              </div>
              <div className="pl-15">
                <span className="custom-text1-primary-medium">-d</span>{" "}
                <span className="custom-text1-primary-medium">'</span>
                <span className="custom-text1-theme-medium">
                  username=firstname%20lastname&firstname=firstname&lastname=lastname&email=email@gmail.com&eventid=
                  {session.eventid}&usercategory={categoryId}&comesfrom=api
                </span>
                <span className="custom-text1-primary-medium">' \</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    userCategoryList: state.userCategoryList,
  };
}
export default connect(mapStateToProps, { fetchUsersCategory, fetchSettings })(
  Apis
);
